export const SUBJECT_LABELS = {
  maths: "Mathematics", science: "Science", social: "Social Science",
  english: "English", hindi: "Hindi", tamil: "Tamil",
  physics: "Physics", chemistry: "Chemistry", biology: "Biology",
  cs: "Computer Science", accountancy: "Accountancy", business: "Business Studies",
  economics: "Economics", history: "History", geography: "Geography",
  polsci: "Political Science",
};

export const subjectLabel = (s) => SUBJECT_LABELS[s] || (s ? s[0].toUpperCase() + s.slice(1) : "");

export const BOARD_LABELS = { cbse: "CBSE", tnboard: "TN State Board" };

export const JEE_SUBJECTS = ["maths", "physics", "chemistry", "science"];
export const NEET_SUBJECTS = ["physics", "chemistry", "biology", "science"];
